<template>
  <div class="othersearchservices">
    <Collapse :id="'othersearchservices-collapse'" :open="isDesktopView">
      <template #button-content-before-icon>
        <span id="othersearchservices-collapse-rubrik">
          {{ texts.andraTjanster }}
        </span>
      </template>
      <template #collapse-content>
        <ul aria-labelledby="othersearchservices-collapse-rubrik">
          <li v-for="service in searchServices" :key="service.id">
            <a :href="service.url">{{ service.text }}</a>
          </li>
        </ul>
      </template>
    </Collapse>
  </div>
</template>
<script>
import Collapse from "../../bootstrap/collapse.vue";

export default {
  name: "OtherSearchServices",
  props: {
    searchServices: Array,
    texts: Object,
  },
  data: function () {
    return {
      isDesktopView: true,
      breakpoint: parseInt(
        getComputedStyle(document.body).getPropertyValue("--bs-breakpoint-xl")
      ),
    };
  },
  components: {
    Collapse,
  },
  created() {
    this.selected = this.selectedFilter;
    this.IsDesktop();
  },
  mounted() {
    window.addEventListener("resize", this.IsDesktop);
  },
  unmounted() {
    window.removeEventListener("resize", this.IsDesktop);
  },
  methods: {
    IsDesktop() {
      this.isDesktopView = window.innerWidth >= this.breakpoint;
    },
  },
};
</script>
